import { createAction, props } from '@ngrx/store';
import { DocumentationEntryForShowDto } from 'app/_models/model/documentationEntryForShowDto';
import { JournalDisplayView } from '../_interface/journal-display-view.enum';
import { JournalConfig } from '../lib/journal.config';
import { IEntryType } from '../_interface/ientry-type';
import { DocumentationEntryForManipulationDto } from 'app/_models/model/documentationEntryForManipulationDto';
import { DocumentationCitizenDto } from 'app/_models/model/documentationCitizenDto';
import { IEntryForShow } from '../_interface/ientry-for-show';
import { ListSortEnum } from '../_interface/list-sort.enum';
import { IFullTemplateField } from '../_interface/itemplate-field';
import { Settings } from 'app/_interfaces/settings.interface';

const pref = '[Jour]';
const prefEdit = '[Jour/Edit]';
const prefWidget = '[Jour/Widget]';
const prefOverview = '[Jour/Overview]';
const prefDrawing = '[Jour/Drawing]';
const prefSettings = '[Jour/Settings]';

// tslint:disable:max-line-length
export const getNewGuid = createAction(`[GUID] request new`);
export const newGuid = createAction(`[GUID] got new`, props<{ guid: string }>());
export const initJournal = createAction(`${pref} Init`);
export const destroyJournal = createAction(`${pref} Destroy`);
export const initOverview = createAction(`${prefOverview} Init`, props<{ id: string }>());
export const getConfig = createAction(`${pref} Get Configuration`, props<{ config: JournalConfig }>());
export const destroyOverview = createAction(`${prefOverview} Destroy`);
export const loadEntries = createAction(`${pref} Load Entries`);
export const loadCitizen = createAction(`${pref} Load Citizen`, props<{ citizenId: string }>());
export const citizenLoaded = createAction(`${pref} Citizen loaded`, props<{ citizen: DocumentationCitizenDto }>());
export const loadEntryTypes = createAction(`${pref} Load EntryTypes`);
export const loadFieldTypes = createAction(`${pref} Load FieldTypes`);
export const entriesLoaded = createAction(`${pref} Load Entries Success`, props<{ entries: DocumentationEntryForShowDto[] }>());
export const convertEntries = createAction(`${pref} Convert Entries`, props<{ templateFields: IFullTemplateField[], entryTypes: IEntryType[], entries: DocumentationEntryForShowDto[] }>());
export const setCitizenId = createAction(`${pref} Set CitizenId`, props<{ id: string }>());
export const citizenIdWithoutChange = createAction(`${pref} CitizenId Not changed`);
export const overviewDataReady = createAction(`${prefOverview} Data Ready`);
export const navigateToView = createAction(`${pref} Navigate to sub filter`, props<{ view: JournalDisplayView }>());
export const sortListBy = createAction(`${pref} Sort list`, props<{ by: ListSortEnum, direction: -1 | 1 }>());
export const printMultipleEntries = createAction(`${pref} Print multiple entries`, props<{ entriesIds: string[] }>());
export const printedMultipleEntries = createAction(`${pref} Print success`, props<{ entriesIds: string[] }>());
export const togglePrintModeByList = createAction(`${pref} Toggle print mode`, props<{ toggle: boolean }>());
export const entriesPerPagedByList = createAction(`${pref} Sort list per page`, props<{ entriesPerPage: number }>());
export const changeOverviewEntriesLimit = createAction(
	`${pref} Change overview entries limit`, props<{ limit: number }>()
);
export const toggleEntryVisibility = createAction(
	`${pref} Toggle Entry Visibility`,
	props<{ entryId: string }>()
);
export const setVisibleEntryIds = createAction(
	`${pref} Set Visible Entry Ids`,
	props<{ entryIds: string[] }>()
);

export const saveEntryForEdit = createAction(`${prefEdit} Save Entry`, props<{ entryId: string, entry: DocumentationEntryForManipulationDto, backToList: boolean }>());
export const entryForEditSaved = createAction(`${prefEdit} Entry saved`, props<{ entryId: string, entry: DocumentationEntryForShowDto, backToList: boolean }>());
export const clearEntryForEditSaved = createAction(`${prefEdit} Clear saved entry`);
export const medicineEntriesLoaded = createAction(`${prefWidget} Medicine entries loaded`, props<{ entries: IEntryForShow[] }>());
export const checkDefaultTemplate = createAction(`${prefOverview} Check default template`);
export const setDefaultTemplateId = createAction(`${prefOverview} Set default template id to settings`, props<{ templateId: string }>());
export const defaultTemplateIsKnown = createAction(`${prefOverview} Default template is known`);

// actions for toggle (fold/unfold) sections in Overview
export const filterEntriesByAuthors = createAction(`${pref} Filter entries by authors`, props<{ authorIds: string[] }>());
export const toggleAllSections = createAction(`${pref} Toggle all sections`, props<{ toggle: boolean }>());
export const filterEntriesByTemplates = createAction(`${pref} Filter entries by template IDs`, props<{ templateIds: string[] }>());
export const filterEntriesByKeywords = createAction(`${pref} Filter by search keyword`, props<{ keyword: string }>());
export const filterEntriesByDateRange = createAction(`${pref} Filter entries by date time`, props<{ from: string, to: string }>());

export const expandAllEntries = createAction(`${pref} Expand All Entries`);
export const foldAllEntries = createAction(`${pref} Fold All Entries`);
export const toggleEntryInOverview = createAction(`${prefOverview} Toggle entry in overview`, props<{ entryId: string, fieldId?: string }>());
export const tryToOpenAndScrollToEntryField = createAction(`${prefOverview} Try to open and scroll to field`, props<{ entryId: string, fieldId: string }>());
export const tryToOpenAndScrollToEntryFieldWithinContainer = createAction(`${prefOverview} Try to open and scroll to field within container`, props<{ entryId: string, fieldId: string, containerName: string }>());

// actions for drawings
export const initDrawings = createAction(`${prefDrawing} Init`);
export const toggleDrawingsBigSize = createAction(`${prefOverview} Toggle drawings big size`);
export const toggleDrawingsDescriptions = createAction(`${prefOverview} Toggle drawings descriptions`);
export const toggleEntriesColumnVisibility = createAction(`${prefOverview} Toggle entries column`);
export const toggleDrawingsColumnVisibility = createAction(`${prefOverview} Toggle drawings column`);
export const selectPlacedSymbolId = createAction(`${prefDrawing} Select placed symbol`, props<{ placedSymbolId: string }>());
export const toggleInactivePlacedSymbols = createAction(`${prefDrawing} Toggle inactive placed symbols`);
export const resetSelectPlacedSymbolId = createAction(`${prefDrawing} Reset placed symbol`);
export const setHiddenSchemaIds = createAction(`${prefDrawing} Set hidden schema id's`, props<{ schemaIds: string[] }>());

// actions for settings
export const initAppSettings = createAction(`${prefSettings} Init App Settings`);
export const initUserSettings = createAction(`${prefSettings} Init User Settings`);
export const loadAppSettings = createAction(`${prefSettings} Load App Settings`, props<{ settings: Settings }>());
export const loadUserSettings = createAction(`${prefSettings} Load User Settings`, props<{ settings: Settings }>());
export const applySettings = createAction(`${prefSettings} Apply Settings`, props<{ settings: Settings }>());
export const fillWithDefaults = createAction(`${prefSettings} Fill With Default Settings`, props<{ settings: Settings }>());
export const saveSingleKey = createAction(`${prefSettings} Save Single Key Setting`, props<{ key: string, value: any }>());
export const submitConsentForCorruptedEntry = createAction(`${prefOverview} Submit consent for corrupted entry`, props<{ entryId: string }>());
export const getTemplateForCorruptedEntry = createAction(`${prefOverview} Get template for corrupted entry`, props<{ templateId: string }>());
